// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3KkVt","header":"ClearentDisclaimer_header__1-pi8","inner":"ClearentDisclaimer_inner__nnklo"};